require('!!raw-loader!/builds/1022221/v2/src/index.html');